import { useContext } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import { AlertContext } from "../utils/contexts";

import HomePage from "./HomePage";
import ComparePage from "./ComparePage";
import DisplayPage from "./DisplayPage";
import FormPage from "./FormPage";

import Footer from "../components/Footer";
import Header from "../components/Header";
import Notification from "../components/Notification";

const PageSelector = (props) => {
  const { open, message, severity, recall } = useContext(AlertContext);

  return (
    <Router>
      <div className="rootContainer">
        <Header />

        <main className="rootExceptFooter">
          <Switch>
            <Route path="/compare">
              <ComparePage />
            </Route>
            <Route path="/display">
              <DisplayPage />
            </Route>
            <Route path="/form">
              <FormPage />
            </Route>
            <Route path="/">
              <HomePage />
            </Route>
          </Switch>
        </main>
        <footer className="rootFooter">
          <Footer />
        </footer>
      </div>
      <Notification
        snackbarOpen={open}
        snackbarMessage={message}
        snackbarSeverity={severity}
        handleClose={recall}
      />
    </Router>
  );
};

export default PageSelector;
